<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <div class="page-head">
          <div>
            <p class="page-kicker">User onboarding</p>
            <h1 class="page-title">ユーザー作成</h1>
            <p class="page-copy">
              アカウント情報とプロフィール情報をまとめて登録します。
              入力順を整理し、作成時に必要なものから先に設定できるようにしています。
            </p>
          </div>
          <div class="page-badge">
            <span class="page-badge__label">Mode</span>
            <span class="page-badge__value">Create</span>
          </div>
        </div>

        <form v-on:submit.prevent="create">
          <div class="editor-grid">
            <section class="profile-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Account</p>
                    <h2 class="section-title">ログイン情報</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label">メールアドレス</label>
                    <input v-model="email" type="email" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">パスワード</label>
                    <input v-model="password" type="password" class="form-control" required />
                  </div>
                </div>
              </div>

              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Main fields</p>
                    <h2 class="section-title">基本情報</h2>
                  </div>
                </div>

                <div class="field-grid field-grid--two">
                  <div class="form-group">
                    <label class="form-label">ID</label>
                    <input v-model="user_identifier" type="text" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">氏名</label>
                    <input v-model="name" type="text" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">生年月日</label>
                    <input v-model="birthday" type="date" pattern="yyyy-mm-dd" class="form-control" required />
                  </div>

                  <div class="form-group">
                    <label class="form-label">登録日</label>
                    <input v-model="joinday" type="date" pattern="yyyy-mm-dd" class="form-control" required />
                  </div>
                </div>
              </div>
            </section>

            <section class="detail-panel">
              <div class="section-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Permissions</p>
                    <h2 class="section-title">権限設定</h2>
                  </div>
                </div>

                <div class="field-grid">
                  <div class="form-group">
                    <label class="form-label" for="userTypeSelect">ユーザータイプ</label>
                    <select id="userTypeSelect" v-model="user_type" class="form-control">
                      <option v-for="ut in user_types" :key="ut.id" :value="ut.id">{{ ut.name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="section-card summary-card">
                <div class="section-head">
                  <div>
                    <p class="section-kicker">Checklist</p>
                    <h2 class="section-title">作成前の確認</h2>
                  </div>
                </div>

                <ul class="summary-list">
                  <li>メールアドレスはログインIDとして使われます。</li>
                  <li>ユーザータイプによって管理権限の有無が変わります。</li>
                  <li>作成後に詳細画面から画像や自己紹介を追加できます。</li>
                </ul>
              </div>
            </section>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary">作成</button>
            <button type="button" v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import store from "@/store";

const NORMAL_USER_TYPE = '1'
const SUPER_USER_TYPE = '2'
const NON_USER_TYPE = '3'

export default {
  data: function () {
    return {
      email: "",
      password: "",
      user_id: "",
      user: {},
      name: "",
      user_identifier: "",
      birthday: "",
      joinday: "",
      self_introduction: "",
      career_summary: "",
      fileInfo: '',
      fileSetted: false,
      user_type: NORMAL_USER_TYPE,
      user_types: [{ id: NORMAL_USER_TYPE, name: "一般ユーザー" }
        , { id: SUPER_USER_TYPE, name: "管理者" }
        , { id: NON_USER_TYPE, name: "お知らせ投稿用" }],
    }
  },
  async mounted() {
  },
  methods: {
    create: function () {

      var is_superuser = false;
      var is_nonuser = false;
      if (this.user_type == NON_USER_TYPE) {
        is_nonuser = true;
      } else if (this.user_type == SUPER_USER_TYPE) {
        is_superuser = true;
      }

      const user_data = {
        email: this.email,
        password: this.password,
        is_superuser: is_superuser,
        is_nonuser: is_nonuser,
      }

      let data = {
          user_id: this.user_id,
          name: this.name,
          user_identifier: this.user_identifier,
          birthday: this.birthday,
          joinday: this.joinday,
          self_introduction: "",
          career_summary: "",
          role: this.role,
          is_superuser: is_superuser,
          is_nonuser: is_nonuser,
        };
      if (data.user_id != "") {
        axios.post("/user_info_create_update", data)
        .then((res) => {
          router.push("/users");
        })
        .catch((error) => {
          alert(error.response.data.detail);
        });
        return;
      }
      axios.post("/user_create", user_data).then((res) => {
        this.user_id = String(res.data.id)
        data.user_id = this.user_id;
        axios.post("/user_info_create_update", data)
        .then((res) => {
          router.push("/users");
        })
        .catch((error) => {
          alert(error.response.data.detail);
        });
      });
    },
    back: function () {
      router.push("/menu")
    },
    logout: function () {
      store.dispatch("logout")
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 1180px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 12px 30px rgba(15,23,42,0.08);
  padding: 32px 40px;
}

.page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.page-kicker {
  margin: 0 0 8px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.page-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1E293B;
  margin: 0;
}

.page-copy {
  max-width: 58ch;
  margin: 12px 0 0;
  color: #64748B;
  font-size: 0.95rem;
  line-height: 1.8;
}

.page-badge {
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
}

.page-badge__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748B;
}

.page-badge__value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 24px;
  align-items: start;
}

.profile-panel,
.detail-panel {
  display: grid;
  gap: 20px;
}

.section-card {
  padding: 20px;
  border-radius: 18px;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
  border: 1px solid #E2E8F0;
}

.section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.section-kicker {
  margin: 0 0 6px;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748B;
}

.section-title {
  margin: 0;
  font-size: 1.08rem;
  font-weight: 700;
  color: #1E293B;
}

.field-grid {
  display: grid;
  gap: 16px;
}

.field-grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-group { margin-bottom: 0; }

.form-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
}

.form-control {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #CBD5E1;
  font-size: 0.9rem;
  background: #FFF;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control:focus {
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59,130,246,0.12);
}

.summary-list {
  margin: 0;
  padding-left: 20px;
  color: #475569;
  line-height: 1.8;
  text-align: left;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding-top: 20px;
  border-top: 1px solid #E2E8F0;
  margin-top: 28px;
}

.btn-primary {
  padding: 10px 24px; border-radius: 12px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-primary:hover { background: #2563EB; transform: translateY(-1px); }

.btn-secondary {
  padding: 10px 24px; border-radius: 12px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s, transform 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; transform: translateY(-1px); }

@media (max-width: 900px) {
  .page-head,
  .section-head {
    flex-direction: column;
  }

  .editor-grid,
  .field-grid--two {
    grid-template-columns: 1fr;
  }

  .page-badge {
    width: 100%;
  }
}

@media (max-width: 640px) {
  .top-header {
    padding: 0 16px;
  }

  .main-content {
    padding: 24px 14px 60px;
  }

  .white-card {
    padding: 22px 18px;
  }

  .section-card {
    padding: 16px;
  }

  .form-actions {
    justify-content: stretch;
  }

  .form-actions > * {
    width: 100%;
  }
}
</style>
